import { twMerge } from 'tailwind-merge';

type DeprecationBannerProps = React.ComponentPropsWithoutRef<'div'> & {
  deprecationDate: string | null | undefined;
  compact?: boolean;
};

export const DeprecationBanner = ({
  deprecationDate: _deprecationDate,
  compact,
  className,
  ...props
}: DeprecationBannerProps) => {
  if (!_deprecationDate) return null;
  const currentDate = new Date();
  const deprecationDate = new Date(_deprecationDate);
  const isAlreadyDeprecated = currentDate > deprecationDate;

  const displayDate = deprecationDate.toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...(!compact && {
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    }),
  });

  return (
    <div {...props} className={twMerge('w-full', className)}>
      <div className="-mb-1 mt-4 w-full rounded-lg bg-bgWarningMuted py-3 text-center text-base">
        {!isAlreadyDeprecated && 'This model will be deprecated on '}
        {isAlreadyDeprecated && 'This model was deprecated on '}
        <span className="whitespace-nowrap">{displayDate}</span>
      </div>
    </div>
  );
};
